<template lang="html">
    <section class="dhmedical">
        <div class="Vlt-card" :style="style">
            <vlt-icon v-if="0 && currentCall" icon="thumbs-up" color="green" />
            <div class="Vlt-grid" style="display: flex; align-items: center;">
                <div class="Vlt-col Vlt-col--A-1of4">
                    <h4 @click="sendClick">A Medical AI HelpBot</h4>
                </div>
                <div class="Vlt-col Vlt-col--A-1of4">
                    <vlt-button v-if="comprehend.length || details" app label="Show Medical Information" tertiary
                        @click="showInfo = true" />
                </div>
            </div>
            <vlt-modal v-if="gear" class="Vlt-modal--large" :message="'Video Options'" :title="'Video Options'"
                :canCancel="false" :visible="gear" @close="closeGear" @confirm="closeGear">
                <div class="Vlt-card">
                    <vlt-checkbox v-if="false" style="margin-bottom:15px" label="Use Translation and Captions "
                        :checked="trans" @change="trans = !trans" />
                    <vue-phone-number-input :default-country-code="nexmo.region" v-model="prettyNumber"
                        @update="onUpdate" />
                    <vlt-checkbox style="margin-top:15px" label="Automatically Notify Proctor/Doctor " :checked="tellDr"
                        @change="tellDr = !tellDr" />
                    <div class="Vlt-grid" style="display: flex; align-items: center;">
                        <div class="Vlt-col Vlt-col--A-1of3">
                            <vlt-field label="Patient">
                                <div class="Vlt-native-dropdown" style="padding-bottom:5px">
                                    <select class="Vlt-select" style="display: inline-block; padding-bottom:10px;"
                                        v-model="ptlang">
                                        <option v-for="item in langs" :value="item.code">{{ item.name }}</option>
                                    </select>
                                </div>
                            </vlt-field>
                        </div>
                        <div class="Vlt-col Vlt-col--A-1of3">
                            <vlt-field label="Doctor">
                                <div class="Vlt-native-dropdown" style="padding-bottom:5px">
                                    <select class="Vlt-select" style="display: inline-block; padding-bottom:10px;"
                                        v-model="drlang">
                                        <option v-for="item in langs" :value="item.code">{{ item.name }}</option>
                                    </select>
                                </div>
                            </vlt-field>
                        </div>
                    </div>
                    <vlt-button app label="Launch Remote Video" tertiary @click="doDr" />
                </div>
            </vlt-modal>
            <vlt-modal v-show="showInfo" class="Vlt-modal--large" :message="'Medical Information'"
                :title="'Medical Information'" :canCancel="false" :visible="showInfo" @close="showInfo = false"
                @confirm="showInfo = false">
                <div class="Vlt-card">
                    <div v-if="details">
                        <h4>Detailed Description:</h4>
                        <h5 style="color:purple;">{{ details }}</h5>
                    </div>
                    <hr class="hr--tall Vlt-gradient--blue-to-pink" />
                    <json-view style="z-index: 1000" :data="comprehend" :maxDepth="6"
                        :rootKey="'Medical Information'" />
                </div>
            </vlt-modal>
            <vlt-modal v-if="showRx" class="Vlt-modal--large" :message="'Choose your Medication'"
                :title="'Choose your Medication'" :canCancel="false" :visible="showRx" @close="showRx = false"
                @confirm="myRx">
                <div class="Vlt-radio" v-for="(r, index) in rx">
                    <label :for="'rx_' + index">
                        <span class="Vlt-radio__button">
                            <input type="radio" :id="'rx_' + index" :value="r.Code" v-model="currentRx" name="rxes" />
                            <span class="Vlt-radio__icon"></span>
                        </span>
                        <b>{{ '' + r.Code + ': ' }}&nbsp;&nbsp;&nbsp;</b> {{ ' ' + r.Description }}
                    </label>
                </div>
                <div class="Vlt-radio">
                    <label :for="'rx_' + 9999">
                        <span class="Vlt-radio__button">
                            <input type="radio" :id="'rx_' + 9999" :value="0" v-model="currentRx" name="rxes" />
                            <span class="Vlt-radio__icon"></span>
                        </span>
                        None of the above
                    </label>
                </div>
            </vlt-modal>
            <div class="Vlt-grid">
                <div v-if="generic && !genStart" :class="grid">
                    <div v-show="false">
                        <vlt-field label="Agent ID :">
                            <vlt-input v-model="ai_agent" :val="ai_agent" />
                        </vlt-field>
                        <vlt-field label="Agent Key :">
                            <vlt-input style="-webkit-text-security: disc;" v-model="ai_key" :val="ai_key" />
                        </vlt-field>
                        <vlt-field label="Agent Region :">
                            <div class="Vlt-native-dropdown">
                                <select class="Vlt-select" style="display: inline-block; height: 25px"
                                    v-model="ai_region">
                                    <option value="us">United States</option>
                                    <option value="eu">Europe</option>
                                </select>
                            </div>
                        </vlt-field>
                        <vlt-checkbox label="Use Medical Transcription" :checked="medical" @change="isMedical" />
                        <vlt-field label="Start Phrase :">
                            <vlt-input v-model="ai_start" :val="ai_start" />
                        </vlt-field>
                    </div>
                    <div v-if="auto">
                        <h3 style="color:Green;">Please wait while we initialize VELMA, the Vonage Electronic Lifelike
                            Medical Assistant</h3>
                    </div>
                    <div v-else>
                        <vlt-button app :disabled="(!ai_agent) || (!ai_key)" label="Restart VELMA" quaternary
                            @click="start" />
                    </div>
                </div>
                <div v-if="0 && inVideo">
                    <iframe width="100%" height="100%" frameborder="0" :src="videoUrl"
                        allow="camera; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen></iframe>
                </div>
                <div v-else-if="(!generic) || genStart" :class="grid">
                    <div class="Vlt-grid">
                        <div class="Vlt-col Vlt-col--A-2of3">
                            <div class="Vlt-grid">
                                <div class="Vlt-col Vlt-col--A-1of3">
                                    <vlt-button label="Click and Hold to Talk"
                                        :class="(isReady && !muted) ? 'Xglowbutton2' : ''" quaternary app
                                        :disabled="false && (!isReady || muted)" @mousedown="activating(true)"
                                        @mouseup="activating(false)" />
                                    <vlt-icon class="Vlt-icon--large"
                                        :icon="activeMic ? 'microphone-full' : 'microphone-mute-full'" width="40px"
                                        height="40px" style="padding-left:10px;display: inline-block;"
                                        :color="activeMic ? 'green' : 'red'" />
                                </div>
                                <div class="Vlt-col Vlt-col--A-1of3" style="display: inline-block;">
                                    Mic Sensitivity
                                    <VueSlideBar v-model="sensitivity" style="display: inline-block; width:100px"
                                        :min="10" :max="90" :lineHeight="6" :processStyle="{
            backgroundColor: 'green'
        }" :tooltipStyles="{
            backgroundColor: 'green',
            borderColor: 'green'
        }" />
                                </div>
                                <div class="Vlt-col Vlt-col--A-1of3" style="display: inline-block;">
                                    <vlt-icon class="Vlt-icon--large" icon="gear" width="40px" height="40px"
                                        style="padding-left:10px;padding-top:10px;display: inline-block;"
                                        @click="doGear" />
                                </div>
                            </div>
                        </div>
                        <div class="Vlt-col Vlt-col--A-1of3">
                            <div v-show="false" class="Vlt-native-dropdown" style="padding-bottom:5px">
                                <select class="Vlt-select"
                                    style="display: inline-block; padding-bottom:10px; margin: 0px 0 0px 25px; "
                                    v-model="persona" @change="personaChange">
                                    <option value="s_m_f_01">Female</option>
                                    <option value="s_m_m_01">Male</option>
                                    <option v-if="nexmo.role == 'admin'" value="gernot">Gernot</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="Vlt-grid">
                        <div class="Vlt-col Vlt-col--A-1of2">
                            <div v-if="(tru && !gernot)">
                                <iframe className="videoTrulience" title="This is the translator" height="400px"
                                    width="600px" :src="'https://www.trulience.com/avatar/' + TRULIENCE_ID + '?micOff=true&connect=true&hideFS=true&hideHangUpButton=true&hideMicButton=true&speakerOn=true&hideChatInput=true&hideChatHistory=true&userId=' +
            nexmo.userid +
            '&msgOnConnect=userid;' +
            nexmo.userid" frameBorder='0'
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; xr-spatial-tracking *"
                                    allowFullScreen></iframe>
                            </div>
                            <div v-else-if="gernot">
                                <img :src="gerimage" style="height:350px;display: inline-block" alt="gernot" />
                                <h4 style="color: green;display: inline-block;width:250px">{{ utterance }}</h4>
                            </div>
                            <div ref="myEDH" @click="unclicked = false" v-else>
                                <span v-if="unclicked" style="color: red"><b>To hear the Digital Human speak, click on
                                        it once the face appears.</b></span>
                                <DHApp style="display: inline-block" @click="unclicked = false" v-if="edhtoken"
                                    :token="edhtoken" :steps="steps" @doVue="completed" :persona='persona' />
                            </div>
                        </div>
                        <div class="Vlt-col Vlt-col--A-1of2">
                            <div v-show="form" class="Vlt-card" style="margin-left:100px;">
                                <h5>Registration Information</h5>
                                <vlt-field label="First Name :">
                                    <vlt-input id="firstname" v-model="formvals.firstname" :val="formvals.firstname" />
                                </vlt-field>
                                <vlt-field label="Last Name :">
                                    <vlt-input id="lastname" v-model="formvals.lastname" :val="formvals.lastname" />
                                </vlt-field>
                                <vlt-field label="Date of Birth :">
                                    <vlt-input id="dob" v-model="formvals.dob" :val="formvals.dob" />
                                </vlt-field>
                                <vlt-field label="Phone :">
                                    <vue-phone-number-input :default-country-code="formvals.country"
                                        v-model="formvals.pretty" />
                                </vlt-field>
                                <vlt-field label="Test :">
                                    <div class="Vlt-native-dropdown">
                                        <select v-model="formvals.test">
                                            <option value="none">Unspecified</option>
                                            <option value="covid">COVID</option>
                                            <option value="strep">Strep</option>
                                            <option value="flu">Flu</option>
                                            <option value="uti">UTI</option>
                                        </select>
                                    </div>
                                </vlt-field>
                            </div>
                        </div>
                    </div>
                    <div v-if="true">
                        <b>-- Or, type your request here...</b>
                        <vlt-field>
                            <div class="Vlt-composite">
                                <vlt-input style="display: inline-block" v-model="newMsg" :val="newMsg"
                                    v-on:keyup.enter="ask" />
                                <div class="Vlt-composite__append">
                                    <vlt-button style="display: inline-block" :label="'Ask ' + who" quaternary app
                                        @click="ask" />
                                </div>
                            </div>
                        </vlt-field>
                    </div>
                    <h3 v-if="!gernot" style="color: green"> {{ joke }}</h3>
                </div>
                <div v-if="0" class="Vlt-col Vlt-col--A-2of3">
                    <b>Delivery/Status messages</b>
                    <div class="Vlt-table Vlt-table--short" style="padding-bottom: 1px;">
                        <table>
                            <thead>
                                <tr>
                                    <th>Time</th>
                                    <th>Message</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in messages">
                                    <td>{{ item.time }}</td>
                                    <td>{{ item.message }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <!--         <div class="Vlt-grid">
                <vlt-button label="Call" secondary app @click="handleCallPress()" :disabled="!isReady || currentCall !== null" />
                <vlt-button label="Hangup" @click="handleHangUpClick" :disabled="!isReady || (currentCall === null)" />
            </div>
     -->
        </div>
    </section>
</template>

<script lang="js">
import {
    $NODEBASE
} from '../base';
import {
    $HTTPDEMO,
    requestHandler
} from '../services/nidsService.js';
import {
    parsePhoneNumberFromString
} from 'libphonenumber-js';
import axios from 'axios';
import {
    VltIcon,
    VltButton,
    VltCard,
    VltTab,
    VltGrid,
    VltCol,
    VltField,
    VltInput,
    VltCheckbox,
    VltRadio,
    VltModal,
} from "@vonagevolta/vue";
import NexmoClient from "nexmo-client";
import Pusher from "pusher-js";
import {
    $HTTP
} from "../services/nidsInternal.js";
import {
    ReactInVue
} from "vuera";

import DHApp from "@/components/dh.jsx";
import {
    nullLiteralTypeAnnotation
} from '@babel/types';
import VueSlideBar from 'vue-slide-bar';
import {
    JSONView
} from "vue-json-component";

export default {
    name: 'inapp',
    data() {
        return {
            form: false,
            trans: true,
            formvals: {
                test: 'none'
            },
            number: '',
            prettyNumber: '',
            numberStuff: {},
            delivery: [],
            isValid: true,
            input: '',
            refresh: true,
            DEMO: {},
            application: {},
            isReady: false,
            currentCall: null,
            dtmf: '',
            fromNumber: '',
            toSip: 'sip:56229140311@jahsvonage.byoc.mypurecloud.com',
            callType: 'sip',
            remoteKey: '',
            joke: '',
            pusher: null,
            demos: [],
            messages: [],
            TRULIENCE_ID: "4127435682171733221",
            newMsg: '',
            roomName: 'tmp',
            client: null,
            muted: false,
            shortTime: false,
            sleep: null,
            ai_agent: "63332c03da391386005c55b9",
            ai_key: "CxmvPqHLUuU573iCxll6DVMAUszHFX", //"pGJFx9iEbXt9FLxgJ352hUl76l7DJa", //"nswRH6wyQeQ8cT6w7DwX8lDqx7oNoC",
            ai_start: "Hello",
            ai_region: "us",
            style: "width:1160px;margin-bottom: 50px",
            grid: "Vlt-col Vlt-col--A-1of2",
            genStart: false,
            who: 'VIDSy',
            steps: [{}],
            edhtoken: null,
            tru: true,
            counter: 10,
            jokeDone: false,
            gernot: false,
            gerimage: "https://vids.vonage.com/gernotspeaks.png",
            gerstop: "https://vids.vonage.com/gernotspeaks.png",
            gerstart: "https://vids.vonage.com/gernotspeaks.gif",
            utterance: '',
            firstMessage: '',
            unclicked: true,
            persona: "s_m_f_01",
            activeMic: false,
            sensitivity: '80',
            medical: true,
            comprehend: [],
            showInfo: false,
            rx: null,
            showRx: false,
            currentRx: null,
            auto: false,
            details: "",
            gear: false,
            xvideoUrl: "https://tokbox-events.herokuapp.com/room/VELMA_2" + "?skip=yes&l=v&mute=no&userName=",
            drvideoUrl: "https://meet.vonagenetworks.net/room/velma?bypass=true", //"https://meetings.vonage.com/?room_token=113512726&skip_prejoin=true&user_display_name=", // Was 470995592, now 428630896
            videoUrl: "https://meet.vonagenetworks.net/room/velma?bypass=true&name=",//"https://meetings.vonage.com/?room_token=113512726&skip_prejoin=true&user_display_name=",
            langdrvideoUrl: "https://vonage-video-rti.herokuapp.com/?name=",
            langvideoUrl: "https://vonage-video-rti.herokuapp.com/?name=",
            drlang: 'es',
            ptlang: 'en',
            langs: [{
                name: 'English',
                code: 'en'
            }, {
                name: 'Spanish',
                code: 'es'
            }, {
                name: 'French',
                code: 'fr'
            }, {
                name: 'Italian',
                code: 'it'
            }],
            inVideo: false,
            needStart: true,
            tellDr: false,
        }
    },
    props: {
        nexmo: {
            type: Object,
            required: false
        },
        demoItems: {
            type: Array,
            required: false
        },
        generic: {
            default: true,
            type: Boolean
        },
    },
    methods: {
        doGear() {
            this.gear = !this.gear;
            console.log("Gear = " + this.gear)
        },
        closeGear() {
            this.gear = false;
            if (this.tellDr) {
                this.sendText("The videoconference will be starting soon. Please prepare: ");
            }
        },
        onUpdate(payload) {
            console.log("dhMedical: Got onUpdate");
            this.numberStuff = payload;
            this.isValid = payload.isValid;
            if (payload.isValid) {
                this.number = this.numberStuff.formattedNumber.replace(/\D/g, '');;
            } else {
                var test = parsePhoneNumberFromString(payload.formattedNumber);
                console.log("Re-checked number: ", test)
                if (test.isValid()) {
                    this.isValid = true;
                    this.number = test.number.replace(/\D/g, '');
                    console.log("new this.number = ", this.number)
                } else {
                    this.isValid = false;
                }
            }
        },
        sendText(msg) {
            var url = this.drvideoUrl + "Doctor%20" + this.nexmo.firstname
            if (this.trans) {
                url = this.langdrvideoUrl.replace('%dr%', this.drlang).replace('%pt%', this.ptlang) + this.nexmo.firstname;
            }
            if (!msg || msg.length < 3) {
                msg = "Please join the VELMA Conference at ";
            }
            let message = msg + url;
            $HTTPDEMO.post('opentokDemo.php/send', {
                to: '' + this.number,
                message: message
            })
        },
        myRx() {
            console.log("Selected Rx = " + this.currentRx);
            this.showRx = false;
            let ok = this.rx.find((thisRx) => {
                if (thisRx.Code == this.currentRx) {
                    return thisRx;
                }
            })
            if (ok) {
                this.ask(this.rx[0].Description + ', Code ' + ok.Code.split('').join(' ')); // Clever way to add spaces between digits
            } else {
                this.ask('Nothing');
            }

        },
        isMedical() {
            this.medical = !this.medical;
            console.log("Use Medical? " + this.medical)
        },
        personaChange() {
            if (this.persona == "gernot") {
                this.gernot = true;
            } else {
                this.gernot = false;
            }
        },
        activating(newMic) {
            this.activeMic = newMic;
            if (this.currentCall) {
                console.log("Active Mic: " + this.activeMic);
                this.currentCall.conversation.me.mute(!this.activeMic);
            }
        },
        completed() {
            console.log("DH completed talking");
            if (this.jokeDone) {
                var audio = new Audio('https://vids.vonage.com/sad.mp3');
                audio.volume = 0.5;
                audio.play();
                let aThis = this;
                let jd = this.jokeDone;
                console.log("In jokedone callback: " + this.jokeDone)
                setTimeout((jd) => {
                    aThis.counter++;
                    aThis.steps = [{
                        id: '' + aThis.counter,
                        message: jd,
                        trigger: null,
                    }];
                    console.log("Updated EDH after joke with: ", aThis.steps[0]);
                    aThis.gerTalk(jd)
                }, 2800, jd)
                this.jokeDone = null;
            }
            this.muted = false;
        },
        sendClick() {
            console.log("Sending click........................")
            this.$refs.myEDH.click();

        },
        async start() {
            this.comprehend = [];
            this.details = "";
            if (0) {
                this.application.callServer("vidsy:" + this.nexmo.userid, "phone", {
                    id: this.nexmo.userid
                });
            }
            let ai = {};
            let timeout = 6000;
            if (this.generic && this.ai_agent && this.ai_key) {
                ai = {
                    agent: this.ai_agent,
                    key: this.ai_key,
                    region: this.ai_region,
                    start: this.ai_start
                }
            }
            let started = await this.DEMO.post('/start', {
                demos: this.demos,
                ai: ai,
                dh: 'tru',
                medical: this.medical,
            });
            if (this.ai_start.toLowerCase() == 'gernot') {
                this.gernot = true;
                timeout = 100;
            }
            if (started) {
                console.log("Started, is generic? " + this.generic)
                this.edhtoken = started.data.dhtoken;
                this.genStart = true;
                this.auto = false;
                this.gotMessages(started.data);
                let aThis = this;
                if (!this.generic) {
                    console.log("Not generic, setting startup timer")
                    setTimeout(() => {
                        this.$refs.myEDH.click();
                        console.log("Sending startup: " + aThis.ai_start)
                        aThis.DEMO.post('/step', {
                            message: aThis.ai_start
                        });
                    }, timeout)
                }
            }
            if (this.tellDr) {
                this.sendText("The videoconference will be starting soon. Please prepare: ");
            }
        },
        logEvent(call) {
            console.log('logEvent');
        },
        setCurrentCall(param) {
            this.currentCall = param
            if (param != null) {
                this.isReady = true;
                //this.currentCall.conversation.me.mute(true);
                console.log("Updated call status: ", param.status)
                if (param.status === 'answered') {
                    this.activating(false);
                }
            }
            console.log("Isready=" + this.isReady + " CurrentCall=" + param);
        },
        launchDemo(data) {
            console.log("vidsy launchDemo", data);
            this.$emit("launchDemo", data);
        },
        refreshTimer() {
            console.log("Setting/Refreshing timer");
            if (this.sleep) {
                clearTimeout(this.sleep)
            }
            let aThis = this;
            this.sleep = setTimeout(() => {
                aThis.launchDemo(null);
            }, 150000)
        },
        handleCallPress() {
            //@click="activating(!activeMic)
            this.unclicked = false;
            this.activating(true);
            console.log("Click to call!!!")
            if (!this.application) {
                this.handleError("No application running");
            } else {
                console.log("Starting ASR");
                this.shortTime = true;
                this.muted = true;
                this.DEMO.post('/listen', {
                    sensitivity: this.sensitivity
                });
                let aThis = this;
                setTimeout(() => {
                    aThis.shortTime = false;
                }, 3000);
            }
        },
        async handleHangUpClick() {
            console.log("hagup? ", this.currentCall);
            if (this.currentCall) {
                await this.currentCall.hangUp();
                console.log("HUNGUP");
            } else {
                console.log("NO CALL IN PROGRESS");
            }
            if (this.application) {
                console.log("Killing VIDSY underlying VAPI application")
                this.application.session.deleteSession()
            }
        },
        gotMessages(msgs) {
            var dtime = (new Date()).toISOString().split('.')[0].replace(/T|Z/g, " ");
            if (msgs && Array.isArray(msgs)) {
                msgs.forEach((msg) => {
                    this.messages.push({
                        time: dtime,
                        message: msg.text,
                    });
                });
            }
        },
        gerTalk(message) {
            if (!this.gernot) {
                return;
            }
            this.gerimage = this.gerstart;
            var msg = new SpeechSynthesisUtterance();
            msg.text = message;
            msg.lang = 'de-AT';
            window.speechSynthesis.speak(msg);
            let aThis = this;
            this.utterance = message;
            msg.onend = function (event) {
                console.log('Utterance has finished being spoken after ' + event.elapsedTime + ' seconds.');
                if (aThis.jokeDone) {
                    aThis.completed();
                }
                aThis.gerimage = aThis.gerstop;
                aThis.muted = false;
            }
        },
        removeEmpty(o) {
            for (var k in o) {
                if (!o[k] || typeof o[k] !== "object") {
                    continue // If null or not an object, skip to the next iteration
                }
                // The property is an object
                this.removeEmpty(o[k]); // <-- Make a recursive call on the nested object
                if (Object.keys(o[k]).length === 0) {
                    delete o[k]; // The object had no properties, so delete that property
                }
            }
            return o;
        },
        async register() {
            console.log("demoItems :");
            console.dir(this.demoItems);
            let id = this.nexmo.userid;
            let res = await this.DEMO.post('/register');
            let ai = null;
            let token = res.data.jwt;
            this.comprehend = [];
            this.details = "";
            if (token) {
                let DC = null;
                if (res.data.DC) {
                    DC = {
                        nexmo_api_url: "https://api" + res.data.DC + ".nexmo.com",
                        url: "wss://ws" + res.data.DC + ".nexmo.com"
                    }
                    console.log(":Setting VIDSY DC: ", DC)
                }
                this.client = new NexmoClient(DC);
                this.application = await this.client.createSession(token);
                this.initializeListener();
                if (0) {
                    this.application.callServer("vidsy:" + id, "phone", {
                        id: id
                    });
                }
                //this.DEMO.post('/connect');
            }
            let pusher = new Pusher(this.nexmo['pusher_key'], { //Pusher Key
                cluster: 'us3',
                forceTLS: true
            });
            this.pusher = pusher;
            this.channel = pusher.subscribe("vidsy");
            this.channel.bind("event_" + this.nexmo.userid, data => {
                console.log("Got data: ", data);
                this.refreshTimer()
                switch (data.event) {
                    case 'form':
                        this.form = true;
                        if (data.data && data.data.field) {
                            this.formvals[data.data.field] = data.data.value;
                            if (data.data.field == 'phone') {
                                if (!data.data.value.startsWith('1')) {
                                    data.data.value = "1" + data.data.value;
                                }
                                this.formvals.pretty = parsePhoneNumberFromString("+" + data.data.value).formatNational();
                                this.formvals.country = parsePhoneNumberFromString("+" + this.nexmo['vfrom']).country;
                            }
                            if (data.data.field == 'test') {
                                this.$swal.fire({
                                    toast: true,
                                    position: 'center',
                                    showConfirmButton: false,
                                    timer: 5000,
                                    timerProgressBar: true,
                                    icon: 'success',
                                    html: '<h5>You are now registered for a ' + data.data.value + ' test!</h5>',
                                    didOpen: (toast) => {
                                        toast.addEventListener('mouseenter', this.$swal.stopTimer)
                                        toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                                    }
                                })

                            }
                        }
                        break;
                    case 'choices':
                        if (data.info) {
                            console.log("Got Rx Data: ", data.info)
                            this.currentRx = data.info[0].Code;
                            this.rx = data.info;
                        }
                        break;
                    case 'medication':
                        if (this.rx) {
                            this.showRx = true;
                        }
                        break;
                    case 'details':
                        if (data.details && (data.details.length > 7)) {
                            console.log("Got Details Data: ", data.details)
                            if (!this.details) {
                                this.details = data.details;
                            } else {
                                this.details += '\r\n\r\n' + data.details;
                            }
                        }
                        if (data.appointment && this.tellDr) {
                            this.sendText('');
                            this.$swal.fire({
                                toast: true,
                                position: 'center',
                                showConfirmButton: false,
                                timer: 5000,
                                timerProgressBar: true,
                                icon: 'success',
                                html: '<h5>The Dr has been notified of the upcoming conference.</h5>',
                                didOpen: (toast) => {
                                    toast.addEventListener('mouseenter', this.$swal.stopTimer)
                                    toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                                }
                            })
                        }
                        break;
                    case 'info':
                        console.log("Got medical info: ", data.info[0])
                        if (data.info[0]) {
                            let obj = this.removeEmpty(data.info[0]);
                            console.log("Got medical converted info: ", data.info[0])
                            if (obj && obj.length) {
                                console.log("Got medical info Emptied object: ", obj)
                                this.comprehend.push(obj)
                            } else {
                                console.log("Pushing Got medical info: ", data.info[0])
                                this.comprehend.push(data.info[0])
                            }
                        }
                        break;
                    case 'quit':
                        setTimeout(() => {
                            this.genStart = false;
                            this.inVideo = true;
                            var url = this.videoUrl + "Patient%20" + this.nexmo.firstname
                            if (this.drlang != this.ptlang) {
                                url = this.langvideoUrl.replace('%dr%', this.drlang).replace('%pt%', this.ptlang) + this.nexmo.firstname;
                            }
                            console.log("Opening video: ", url)
                            window.open(url, "_blank", "width=960, height=600, left=250, top=-1000, alwaysRaised");
                        }, 5000);
                        break;
                    case 'edh':
                        // Look for '<jokedone>'
                        let message = data.message;
                        if (message.startsWith('{MEDICATION}')) {
                            message = data.message.slice(12);
                            if (this.rx) {
                                this.showRx = true;
                            }
                        }
                        let strip = message.replace(/\n|\r|\\\|\\|\""|"/g, " ");
                        let parts = strip.split('<jokedone>');
                        this.counter++;
                        if (!this.firstMessage) {
                            let aThis = this;
                            aThis.firstMessage = parts[0];
                            setTimeout((part) => {
                                console.log("Finally sending...");
                                //aThis.firstMessage = '';
                                aThis.steps = [{
                                    id: '' + aThis.counter,
                                    message: part,
                                    trigger: null,
                                }];
                                setTimeout((aThis) => {
                                    aThis.muted = false;
                                }, 9000, aThis);
                            }, 1000, parts[0]);
                            break;
                        }
                        this.steps = [{
                            id: '' + this.counter,
                            message: parts[0],
                            trigger: null,
                        }];
                        this.gerTalk(parts[0])
                        if (parts[1]) {
                            console.log("JokeDone flag!")
                            this.jokeDone = parts[1];
                        }
                        console.log("Updated EDH with: ", this.steps[0]);
                        break;
                    case 'muted':
                        this.muted = data.muted;
                        console.log("Muting: " + this.muted + "isReady=" + this.isReady)
                        break;
                    case 'joke':
                        this.joke = data.msg;
                        console.log("Setting joke to: " + this.joke);
                        break;
                    case 'jokedone':
                        var audio = new Audio('https://vids.vonage.com/sad.mp3');
                        audio.volume = 0.1;
                        audio.play();
                        console.log("Done with joke");
                        break;
                    case 'song':
                    case 'demo':
                        var demoId;
                        if (data.event == 'song') {
                            demoId = 103;
                        } else if (data.msg) { // Ok, get tricky... gotta find the right one!
                            if (data.msg.length > 0) {
                                demoId = data.msg[0].id
                            }
                        }
                        if (demoId) {
                            console.log("Found demoId for " + data.msg + " : " + demoId);
                            let demo = this.demoItems.find((o) => {
                                if (o && o.id && o.id == demoId) {
                                    return o;
                                }
                            });
                            if (demo) {
                                this.launchDemo(demo);
                            } else {
                                this.joke = "Cannot find " + data.msg + " demo";
                            }
                        }
                        break;
                    case 'search':
                        let str = data.msg.join(' ');
                        str = str.replace(/,/g, '');
                        console.log("Normalized Search string: " + str)
                        this.$emit("doSearch", {
                            points: [],
                            keywords: str,
                            from: 'vidsy'
                        });
                        break;
                    case 'connected':
                        break;
                    default:
                }
            });
            this.application.callServer("vidsy:" + this.nexmo.userid, "phone", {
                id: this.nexmo.userid
            });
            setTimeout(() => {
                this.start();
            }, 3000);
        },
        setIsReady(param) {
            this.isReady = param
        },
        doDr() {
            var url = this.drvideoUrl + "Doctor%20" + this.nexmo.firstname
            if (this.drlang != this.ptlang) {
                url = this.langdrvideoUrl.replace('%dr%', this.drlang).replace('%pt%', this.ptlang) + this.nexmo.firstname;
            }
            console.log("Dr Video: ", url, this.drlang, this.ptlang)
            window.open(url, "_blank", "width=960, height=600, left=250, top=-1000, alwaysRaised");
        },
        initializeListener() {
            this.setIsReady(false);
            this.application.on("call:status:changed", async (call) => {
                console.log("Call status changed: ", call.status);
                const {
                    STARTED,
                    COMPLETED,
                    BUSY,
                    TIMEOUT,
                    UNANSWERED,
                    REJECTED,
                    FAILED,
                    RINGING,
                    ANSWERED
                } = call.CALL_STATUS;
                if (call.status === STARTED || call.status === RINGING || call.status === ANSWERED) {
                    console.log('Started call');
                    this.setCurrentCall(call);
                } else if (call.status === COMPLETED || call.status === BUSY || call.status === TIMEOUT ||
                    call.status === UNANSWERED || call.status === REJECTED || call.status === FAILED) {
                    this.setCurrentCall(null);
                } else {
                    console.log("Uncaptured status");
                    //this.setCurrentCall(call);
                }
                this.logEvent(call);
            });
            this.application.on("member:call", (member, call) => {
                console.log("Call started!!!")
                if (call.direction == 'inbound') {
                    console.log("INBOUND CALL");
                    this.setCurrentCall(call);
                    this.currentCall.answer();
                }
            });
            //this.setIsReady(true);
            console.log("Waiting for call");
        },
        async ask(msg) {
            let comp = false;
            if (!(typeof msg == 'string')) {
                msg = this.newMsg
                comp = true;
                console.log('comp =  ' + comp)
            }
            console.log("Processing manual input: " + msg)
            // Look for '<jokedone>'
            this.unclicked = false;
            if (msg.toLowerCase().indexOf('gernot') >= 0) {
                this.gernot = true;
            }
            if (msg && (msg.length > 0)) {
                this.joke = '';
                let step = await this.DEMO.post('/step', {
                    message: msg,
                    comprehend: comp,
                });
                console.log("Step: ", step.data);
                if (0 && step) {
                    if (step.data.length > 0) {
                        let msg = '';
                        step.data.forEach((message) => {
                            msg += message.text;
                        })
                        this.counter++;
                        this.steps = [{
                            id: '' + this.counter,
                            message: msg,
                            trigger: null,
                        }]
                        console.log("Updated EDH with: ", this.steps[0]);
                    }
                    this.gotMessages(step.data);
                }
                this.newMsg = '';
            }
        },
    },
    components: {
        "vlt-icon": VltIcon,
        "vlt-button": VltButton,
        "vlt-field": VltField,
        "vlt-input": VltInput,
        "vlt-checkbox": VltCheckbox,
        "vlt-modal": VltModal,
        DHApp: DHApp,
        VueSlideBar,
        "json-view": JSONView,
    },

    created() {
        if (this.generic) {
            this.style = "width:1700px;margin-bottom: 50px";
            this.grid = "Vlt-col Vlt-col--A-2of3";
            this.who = 'Assistant';
        } else {
            $HTTP.post("startdemo", {
                demo: 'Demo vidsy2',
                event: 'launch',
                status: 'Success',
                results: "VIDSy Agent",
                comment: 'demo',
            })
        }
        var postscript = "/vidsy";
        if ($NODEBASE.indexOf('ngrok') > 0) {
            postscript = '';
        };
        var url = $NODEBASE + postscript;
        this.DEMO = axios.create({
            baseURL: url,
            headers: {
                'Content-Type': 'application/json'
            }
        });
        this.DEMO.interceptors.request.use(
            request => requestHandler(request)
        );
        /*
        this.DEMO.post('/sentiment', {
            text: 'This is a really great demo.  It is nice.  But some of it sucks.'
        }).then((sentiment) => {
            console.log("SENTIMENT: ", sentiment.data)
        })
        */
        this.register();
        console.log("Nexmo: ", this.nexmo)
        var ph = this.nexmo.info.phone2 ? this.nexmo.info.phone2 : this.nexmo['phone'];
        this.prettyNumber = parsePhoneNumberFromString("+" + ph).formatNational();
        this.fromNumber = parsePhoneNumberFromString("+" + this.nexmo['vfrom']).formatInternational();
        console.log("Vidsy generic demo: ", this.generic)
    },
    mounted() { },
    beforeDestroy() {
        console.log("beforeDestroy for vidsy");
        this.handleHangUpClick();
        if (this.pusher) {
            this.pusher.unsubscribe("vidsy");
        }
    },

}
</script>

<style lang="scss">
.glowbutton2 {
    background-color: #004a7f;
    -webkit-border-radius: 10px;
    border-radius: 10px;
    border: none;
    color: #ffffff;
    cursor: pointer;
    display: inline-block;
    font-family: Arial;
    font-size: 20px;
    padding: 5px 10px;
    text-align: center;
    text-decoration: none;
    -webkit-animation: glowingCSS 1500ms infinite;
    -moz-animation: glowingCSS 1500ms infinite;
    -o-animation: glowingCSS 1500ms infinite;
    animation: glowingCSS 1500ms infinite;
}

@-webkit-keyframes glowingCSS {
    0% {
        background-color: #00b200;
        -webkit-box-shadow: 0 0 3px #00b000;
    }

    50% {
        background-color: #00ff00;
        -webkit-box-shadow: 0 0 40px #00ff00;
    }

    100% {
        background-color: #00b20000;
        -webkit-box-shadow: 0 0 3px #00b200;
    }
}

@-moz-keyframes glowingCSS {
    0% {
        background-color: #00b200;
        -moz-box-shadow: 0 0 3px #00b200;
    }

    50% {
        background-color: #00ff00;
        -moz-box-shadow: 0 0 40px #00ff00;
    }

    100% {
        background-color: #00b200;
        -moz-box-shadow: 0 0 3px #00b200;
    }
}

@-o-keyframes glowingCSS {
    0% {
        background-color: #00b200;
        box-shadow: 0 0 3px #00b200;
    }

    50% {
        background-color: #00ff00;
        box-shadow: 0 0 40px #00ff00;
    }

    100% {
        background-color: #00b200;
        box-shadow: 0 0 3px #00b200;
    }
}

@keyframes glowingCSS {
    0% {
        background-color: #00b200;
        box-shadow: 0 0 3px #00b200;
    }

    50% {
        background-color: #00ff00;
        box-shadow: 0 0 40px #00ff00;
    }

    100% {
        background-color: #00b200;
        box-shadow: 0 0 3px #00b200;
    }
}

m1 {
    animation: glow 10s ease-in-out infinite;
    animation: none;

    /* For less laggy effect, uncomment this:

      animation:none;
      -webkit-text-stroke:1px #fff; 

    =========== */
}

@keyframes glow {

    0%,
    100% {
        text-shadow: 0 0 30px red;
    }

    25% {
        text-shadow: 0 0 30px orange;
    }

    50% {
        text-shadow: 0 0 30px forestgreen;
    }

    75% {
        text-shadow: 0 0 30px cyan;
    }
}
</style>
